import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {GroupService} from '../../../services/group-details/group.service';
import {AddPostToProject} from '../../../../models/influencer';
import {Project} from '../../../../models/project/project';
import { ActionSource } from '../../../services/event-tracker/event-tracker.service';
import { ActivePage } from '../../../../models/event-tracker';

@Component({
  selector: 'add-posts-to-project',
  templateUrl: './add-posts-to-project.component.html',
  styleUrls: ['./add-posts-to-project.component.scss']
})
export class AddPostsToProjectComponent {

  @Output()
  public backToPreviewInfluencerEvent = new EventEmitter<any>();
  @Output()
  public addPostsToProjectExecution = new EventEmitter<any>();
  @Output()
  public createNewProjectEvent = new EventEmitter<any>();
  @Input()
  public projectList: any[] = [];
  @Input()
  public isShowSummarize = false;
  @Input()
  public numberSelectedPost = 1;
  @Input()
  public activePage: ActivePage;

  public postAddToProject: AddPostToProject = new AddPostToProject();
  public selectedProject: Project;


  constructor(private groupService: GroupService,
              private userService: UserService) { }

  addPostsToProject() {
    this.addPostsToProjectExecution.emit(this.postAddToProject);
  }

  onSelectProject(project) {
    this.selectedProject = new Project();
    this.selectedProject.keywords = project.keywords;
    this.selectedProject.countries = project.countries;
    this.postAddToProject.projectName = project.name;
    this.postAddToProject.projectId = project.id;
  }

  backToPreviewInfluencer() {
    this.backToPreviewInfluencerEvent.emit();
  }

  createNewProject() {
    this.createNewProjectEvent.emit();
  }

  get actionSource() {
    return ActionSource.ACTION_VIEW;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/add-posts-to-project/add-posts-to-project.component.ts